module.exports = __webpack_public_path__ + "img/41.10.pH.236ea97e.png";